'use client'

import { ReactNode, useState } from 'react'

import { FormMode } from 'shared/types/forms'
import { Modal, ModalTitle } from 'shared/ui/Modal'
import { KEYBOARD_KEYS } from 'shared/ui/types'
import { addTestId } from 'shared/utils/tests'

import { AddressServiceSingleton } from '../../mappers'
import { CustomerInvoiceAddress } from '../../types'
import { FormAddInvoiceAddress } from '../FormAddInvoiceAddress'

import styles from './ModalAddInvoiceAddress.module.scss'

type ModalAddInvoiceAddressTypes = {
  mode: FormMode
  trigger: ReactNode
  address?: CustomerInvoiceAddress
}

const ModalAddInvoiceAddress = ({
  trigger,
  address,
  mode
}: ModalAddInvoiceAddressTypes) => {
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <div className={styles.triggerWrapper}
        onKeyDown={e => {
          if (e.key === KEYBOARD_KEYS.ENTER) {
            e.preventDefault()
            e.stopPropagation()
            void handleOpen()
          }
        }}
        role='button'
        tabIndex={0}
        aria-label='Edytuj adres'
        onClick={e => {
          e.stopPropagation()
          void handleOpen()
        }}
      >
        {trigger}
      </div>
      <Modal
        id={`${mode === FormMode.edit ? 'edit' : 'add'}-invoice-address-modal`}
        open={open}
        onClose={handleClose}
        size='large'
        {...addTestId('add-invoice-address-modal')}
      >
        <ModalTitle>{`${mode === FormMode.edit ? 'Edytuj' : 'Dodaj nowy'} podmiot`}</ModalTitle>
        <FormAddInvoiceAddress
          mode={mode}
          defaultValues={AddressServiceSingleton.mapInvoiceResponseToFormValues(
            address
          )}
          handleClose={handleClose}
        />
      </Modal>
    </>
  )
}

export default ModalAddInvoiceAddress
